import { render, staticRenderFns } from "./RiskAssessmentProcess.vue?vue&type=template&id=344f0d65&scoped=true&"
import script from "./RiskAssessmentProcess.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentProcess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344f0d65",
  null
  
)

export default component.exports